import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ParticipantForm from './ParticipantForm';
import PassphraseCheck from './PassphraseCheck';

const AddParticipant: React.FC = () => {
  const navigate = useNavigate();
  const [accessGranted, setAccessGranted] = useState(false);
  
  const handleSuccess = () => {
    //navigate('/'); // Redirect to the participants list on success
  };

  return (
    !accessGranted ? <PassphraseCheck onAccessGranted={() => setAccessGranted(true)} />
    :<ParticipantForm onSubmitSuccess={handleSuccess} />
  );
};

export default AddParticipant;
